import type { PropType } from 'vue'
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'FormElement',
  props: {
    title: {
      type: String,
      required: false,
    },
    tagName: {
      type: String as PropType<'input' | 'textarea'>,
      default: 'input',
    },
    isRequired: { type: Boolean, required: false, default: false },
    disabled: { type: Boolean, required: false, default: false },
    errorText: { type: Array, required: false },
    status: { type: String, required: false, default: 'error' },
    value: { type: [String, Number], required: true },
    placeholder: { type: String, required: false },
    maxLength: { type: Number, required: false },
    isPlaceholderStatic: { type: Boolean, required: false, default: true },
    titleClass: {
      type: String as PropType<'grey-14' | 'black-18'>,
      default: 'grey-14',
    },
  },
  emits: ['update:value'],
  setup(_, { emit }) {
    const focused = ref(false)

    const onInput = (event: Event & { target: HTMLInputElement }) => {
      const { value } = event.target as HTMLInputElement
      if (event.target.inputMode === 'numeric') {
        const numValue = value.replace(/\D/g, '')
        event.target.value = numValue
        emit('update:value', numValue)
      } else {
        emit('update:value', value)
      }
    }

    const onFocus = () => {
      focused.value = true
    }

    const onBlur = () => {
      focused.value = false
    }

    return { focused, onInput, onFocus, onBlur }
  },
})
